import { BooleanDimension } from './boolean-dimension.ts'

export const esMrpwSelectedDimension = new BooleanDimension({
  name: 'esMrpwSelected',
  displayKeys: { name: 'dimension_name_es_mrpw_selected' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const esRcphSelectedDimension = new BooleanDimension({
  name: 'esRcphSelected',
  displayKeys: {
    name: 'dimension_name_es_rcph_selected',
  },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const frPrelSelectedDimension = new BooleanDimension({
  name: 'frPrelSelected',
  displayKeys: { name: 'dimension_name_fr_prel_selected' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const mrpSelectedDimension = new BooleanDimension({
  name: 'mrpSelected',
  displayKeys: { name: 'dimension_name_mrp_selected' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const mrpaSelectedDimension = new BooleanDimension({
  name: 'mrpaSelected',
  displayKeys: { name: 'dimension_name_mrpa_selected' },

  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const mrphSelectedDimension = new BooleanDimension({
  name: 'mrphSelected',
  displayKeys: { name: 'dimension_name_mrph_selected' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const mrpwSelectedDimension = new BooleanDimension({
  name: 'mrpwSelected',
  displayKeys: { name: 'dimension_name_mrpw_selected' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const frRcpwSelectedDimension = new BooleanDimension({
  name: 'frRcpwSelected',
  displayKeys: { name: 'dimension_name_fr_rcpw_selected' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const mutaSelectedDimension = new BooleanDimension({
  name: 'mutaSelected',
  displayKeys: { name: 'dimension_name_muta_selected' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const nlRcphSelectedDimension = new BooleanDimension({
  name: 'nlRcphSelected',
  displayKeys: { name: 'dimension_name_nl_rcph_selected' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const rcdaSelectedDimension = new BooleanDimension({
  name: 'rcdaSelected',
  displayKeys: { name: 'dimension_name_rcda_selected' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const rcpaSelectedDimension = new BooleanDimension({
  name: 'rcpaSelected',
  displayKeys: { name: 'dimension_name_rcpa_selected' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const rcpaxaSelectedDimension = new BooleanDimension({
  name: 'rcpaxaSelected',
  displayKeys: { name: 'dimension_name_rcpaxa_selected' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const rcphSelectedDimension = new BooleanDimension({
  name: 'rcphSelected',
  displayKeys: { name: 'dimension_name_rcph_selected' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const frRccwSelectedDimension = new BooleanDimension({
  name: 'frRccwSelected',
  displayKeys: { name: 'dimension_name_fr_rccw_selected' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const nlAovqlSelectedDimension = new BooleanDimension({
  name: 'nlAovqlSelected',
  displayKeys: { name: 'dimension_name_nl_aovql_selected' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const frAupaSelectedDimension = new BooleanDimension({
  name: 'frAupaSelected',
  displayKeys: { name: 'dimension_name_fr_aupa_selected' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const frMrgaSelectedDimension = new BooleanDimension({
  name: 'frMrgaSelected',
  displayKeys: { name: 'dimension_name_fr_mrga_selected' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const frMrpaxeSelectedDimension = new BooleanDimension({
  name: 'frMrpaxeSelected',
  displayKeys: { name: 'dimension_name_fr_mrpaxe_selected' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const frRcpaxeSelectedDimension = new BooleanDimension({
  name: 'frRcpaxeSelected',
  displayKeys: { name: 'dimension_name_fr_rcpaxe_selected' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const esMrpaxeSelectedDimension = new BooleanDimension({
  name: 'esMrpaxeSelected',
  displayKeys: { name: 'dimension_name_es_mrpaxe_selected' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
